import useJobStatusUpdates, { type JobStatusUpdate } from '../utils/useJobStatusUpdates';

interface UseAppSyncSubscriptionOptions {
  userId: string | null;
  jobId?: string | null;
  getAuthToken: () => Promise<string | null>;
  onStatusUpdate?: (update: JobStatusUpdate) => void;
}

export function useAppSyncSubscription(options: UseAppSyncSubscriptionOptions) {
  return useJobStatusUpdates(options);
}

export type { JobStatusUpdate };
